import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DropdownField } from '@/components';

export type PendingPaymentsFiltersType = {
  status: string;
};

type PendingPaymentsFiltersProps = {
  onChange: (filters: PendingPaymentsFiltersType) => void;
  initialFilters?: PendingPaymentsFiltersType;
};

const PendingPaymentsFilters: FC<PendingPaymentsFiltersProps> = ({
  onChange,
  initialFilters,
}) => {
  const { t } = useTranslation('pendingPayments');

  const statuses = [
    {
      name: t('toPay'),
      value: '0',
    },
    {
      name: t('all'),
      value: '-1',
    },
    {
      name: t('inProcess'),
      value: '1',
    },
    {
      name: t('paid'),
      value: '2',
    },
  ];

  const initialFiltersState: PendingPaymentsFiltersType = {
    status: statuses[0].value,
  };

  const [filters, setFilters] = useState<PendingPaymentsFiltersType>(
    initialFilters || initialFiltersState
  );

  const handleFilterChange = (value: string | null, field: string) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    setFilters(newFilters);
    onChange(newFilters);
  };

  return (
    <div className="w-full flex">
      <DropdownField
        className="w-full md:w-20rem"
        id="status"
        name="status"
        multiple
        value={filters?.status}
        onChange={(e) => handleFilterChange(e.value, 'status')}
        options={statuses}
        label={t('filters.status')}
      />
    </div>
  );
};

export default PendingPaymentsFilters;
